import { useNavigate, useParams } from "react-router-dom";
import {useState} from "react"

import { updateResearchPaperApi } from "src/network/api";
import { toast } from "react-toastify";
import PageLayout from "./PageLayout";
import { Button, Card, CardBody, CardHeader } from "reactstrap";
import {
  ResearchPaperForm,
} from "./CommonResearchPaperForm";
import LoaderComponent from "./components/LoaderComponent";
const UpdateResearchPage = () => {


  const navigate = useNavigate();
   const [loading, setLoading] = useState(false);

  const { researchPaperId } = useParams();

  const onSubmit = async (data) => {
    try {
      let response = await updateResearchPaperApi(researchPaperId, data);
      if (response.status === 200 && response.data.status === 200) {
        toast.success(response.data.message || "Research paper Updated successfully!");
        navigate("/my-papers");
      } else {
        toast.error(
          response.data.message || "Failed to Update Research paper."
        );
      }
    } catch (e) {
              console.error("update Failed:", e);
              toast.error(e.response?.data?.message ?? e.message);
            } 
  };

  
  if (loading) {
    return <LoaderComponent />;
  }

  return (
    <PageLayout>
      <div className="mt-5 mb-5 container">
        <div className="mx-auto">
          <Card className="border-0 shadow-lg rounded-4">
            <CardHeader className="bg-primary text-white text-center">
              <h3 className="mb-0 text-white">
                {researchPaperId
                  ? "Update Research Paper"
                  : "Submit Research Paper"}
              </h3>
            </CardHeader>
            <CardBody className="py-4">
              <ResearchPaperForm
                researchPaperId={researchPaperId}
                onSubmit={onSubmit}
                submitButton={
                  <Button
                    color="primary"
                    type="submit"
                    className="btn-block fw-bold py-2 rounded-3"
                    disabled={loading}
                  >
                    {researchPaperId
                      ? "Update / Save Changes"
                      : "Add Research Paper"}
                  </Button>
                }
              />
            </CardBody>
          </Card>
        </div>
      </div>
    </PageLayout>
  );
};

export default UpdateResearchPage;
